import { useCallback } from "react"
import { graphql, UseMutationConfig } from "react-relay"
import { useMutationWithErrorDialog } from "@/hooks/useMutationWithErrorDialog"
import { DEFAULT_SIGNING_MUTATION_PARAMS } from "@/modules/patients/detail/conclude/services/useDocumentSigning"
import {
  Ch_signNeuropsychologicDiagnosticPrescriptionDocumentInput,
  useChSignNeuropsychologicDiagnosticPrescriptionMutation as useChSignNeuropsychologicDiagnosticPrescriptionMutationType,
} from "@/modules/patients/detail/neuropsychologic-diagnostic-prescription/ch/services/__generated__/useChSignNeuropsychologicDiagnosticPrescriptionMutation.graphql"

const mutation = graphql`
  mutation useChSignNeuropsychologicDiagnosticPrescriptionMutation(
    $input: Ch_signNeuropsychologicDiagnosticPrescriptionDocumentInput!
  ) {
    ch_signNeuropsychologicDiagnosticPrescriptionDocument(input: $input) {
      ch_NeuropsychologicDiagnosticPrescription {
        id
        createdAt
        createdBy
        signedBy
        signedAt
        updatedAt
        updatedBy
        fileId
        ...chNeuropsychologicDiagnosticPrescriptionDrawerFragment
      }
      errors {
        ... on Error {
          message
        }
      }
    }
  }
`

type Config = Omit<UseMutationConfig<useChSignNeuropsychologicDiagnosticPrescriptionMutationType>, "variables"> & {
  id: Ch_signNeuropsychologicDiagnosticPrescriptionDocumentInput["id"]
}

const useChSignNeuropsychologicDiagnosticPrescriptionMutation = () => {
  const [commit, isFlight] = useMutationWithErrorDialog<useChSignNeuropsychologicDiagnosticPrescriptionMutationType>(
    mutation,
    DEFAULT_SIGNING_MUTATION_PARAMS,
  )

  const commitHandler = useCallback(
    async (config: Config) => {
      commit({
        variables: {
          input: {
            id: config.id,
          },
        },
        ...config,
      })
    },
    [commit],
  )

  return [commitHandler, isFlight] as const
}

export { useChSignNeuropsychologicDiagnosticPrescriptionMutation }
